var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSeePassword(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F68FEBBB-E939-4756-B6A2-CECAECF6A495") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI-kit-WIP",
    transform: "translate(-286.000000, -359.000000)",
    fill: "#C8CCD2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input",
    transform: "translate(60.000000, 340.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236,19 C232.178787,19 228.713511,21.104324 226.15649,24.5223061 C225.947837,24.8023336 225.947837,25.1935484 226.15649,25.4735758 C228.713511,28.895676 232.178787,31 236,31 C239.821213,31 243.286489,28.895676 245.84351,25.4776939 C246.052163,25.1976664 246.052163,24.8064516 245.84351,24.5264242 C243.286489,21.104324 239.821213,19 236,19 Z M236.274113,29.2251201 C233.737547,29.3857241 231.642835,27.2814001 231.802393,24.7240906 C231.933313,22.6156486 233.631175,20.9066575 235.725887,20.7748799 C238.262453,20.6142759 240.357165,22.7185999 240.197607,25.2759094 C240.062596,27.3802334 238.364734,29.0892244 236.274113,29.2251201 Z M236.147284,27.273164 C234.780812,27.3596431 233.651631,26.2271791 233.741639,24.8517502 C233.81119,23.7151682 234.727626,22.7968428 235.856807,22.7227179 C237.223279,22.6362388 238.35246,23.7687028 238.262453,25.1441318 C238.18881,26.2848318 237.272374,27.2031572 236.147284,27.273164 Z",
    id: "icon-seePassword"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSeePassword);
export default __webpack_public_path__ + "static/media/icon-seePassword.da76bfb7ed0acd32687aa452fdf22f20.svg";
export { ForwardRef as ReactComponent };